// import { m } from 'framer-motion';
// @mui
import { useTheme } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';
// sections
// import getVariant from 'src/sections/_examples/extra/animate-view/get-variant';
// components
// import { MotionContainer } from '../animate';

// ----------------------------------------------------------------------

export default function Loading({ sx, ...other }: BoxProps) {
  // const lines = 12;
  const size = 24;
  // const lineWidth = 2;
  // const lineHeight = 8;
  // const center = size / 2;
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: 10,
        height: 10,
        color: theme.palette.mode === 'dark' ? 'white' : 'grey.800',
        '& div': {
          transformOrigin: '0px 10px', // circle center
          animation: 'spinnerFade 1.2s linear infinite',
          position: 'absolute',
          width: 2, // narrow
          height: 5, // long
          background: 'currentColor',
          borderRadius: 1,
          top: 7,
          left: 11,
        },
        '& div:nth-of-type(1)': { transform: 'rotate(0deg)', animationDelay: '-1.1s' },
        '& div:nth-of-type(2)': { transform: 'rotate(30deg)', animationDelay: '-1s' },
        '& div:nth-of-type(3)': { transform: 'rotate(60deg)', animationDelay: '-0.9s' },
        '& div:nth-of-type(4)': { transform: 'rotate(90deg)', animationDelay: '-0.8s' },
        '& div:nth-of-type(5)': { transform: 'rotate(120deg)', animationDelay: '-0.7s' },
        '& div:nth-of-type(6)': { transform: 'rotate(150deg)', animationDelay: '-0.6s' },
        '& div:nth-of-type(7)': { transform: 'rotate(180deg)', animationDelay: '-0.5s' },
        '& div:nth-of-type(8)': { transform: 'rotate(210deg)', animationDelay: '-0.4s' },
        '& div:nth-of-type(9)': { transform: 'rotate(240deg)', animationDelay: '-0.3s' },
        '& div:nth-of-type(10)': { transform: 'rotate(270deg)', animationDelay: '-0.2s' },
        '& div:nth-of-type(11)': { transform: 'rotate(300deg)', animationDelay: '-0.1s' },
        '& div:nth-of-type(12)': { transform: 'rotate(330deg)', animationDelay: '0s' },
        '@keyframes spinnerFade': {
          '0%': { opacity: 1 },
          '100%': { opacity: 0 },
        },
      }}
    >
      {Array.from({ length: 12 }).map((_, i) => (
        <div key={i} />
      ))}
    </Box>
  );
}
